import React, { FC } from 'react';
import { TSearchSwitchProps, TSearchSwithOptionsProps } from '../../../../types/dealerLocatorLanding.types';

export const SwitchOption: FC<TSearchSwithOptionsProps> = ({ children }) => <>{children}</>;

const SearchTypeSwitch: FC<TSearchSwitchProps> = ({ type, children }) => {
  if (Array.isArray(children)) {
    return <>{children.filter((child) => child?.props && child?.props?.typeName === type)}</>;
  }

  if (children && children?.props?.typeName === type) {
    return <>{children}</>;
  }

  return <></>;
};

export default SearchTypeSwitch;
